import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FAQ_LIST } from './constants';
import { FAQ } from './type';

@Component({
  selector: 'app-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class FAQSectionComponent {
  faqs: FAQ[] = FAQ_LIST;

  toggleFAQ(faq: FAQ): void {
    faq.isOpen = !faq.isOpen;
  }

  formatAnswer(answer: string): string[] {
    return answer.split('\n').filter(line => line.trim() !== '');
  }

  getFormattedAnswer(faq: FAQ): string {
    const lines = faq.answer.split('\n').filter(line => line.trim() !== '');
    
    return lines.map(line => {
      const trimmedLine = line.trim();
      // Si la línea empieza con '•', es un bullet point
      if (trimmedLine.startsWith('•')) {
        return `<p class="mb-2 text-[14px] flex font-poppins items-start gap-2"><span class="flex-shrink-0">•</span><span class="flex-1">${trimmedLine.substring(1).trim()}</span></p>`;
      } else {
        return `<p class="mb-2 text-[14px] font-poppins">${trimmedLine}</p>`;
      }
    }).join('');
  }
}
